/* global window */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

function encodeProp(key, value) {
  if (value === true) {
    value = 'yes';
  } else if (value === false) {
    value = 'no';
  }
  return `${key}=${value}`;
}

function encodeProps(props) {
  const encodedProps = Object.keys(props).reduce((memo, key) => {
    const value = props[key];
    if (typeof value !== 'undefined') {
      memo.push(encodeProp(key, value));
    }
    return memo;
  }, []);
  return encodedProps.join(',');
}

export const windowShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  center: PropTypes.bool,
  left: PropTypes.number,
  top: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
  menubar: PropTypes.bool,
  toolbar: PropTypes.bool,
  location: PropTypes.bool,
  personalbar: PropTypes.bool,
  directories: PropTypes.bool,
  status: PropTypes.bool,
  resizable: PropTypes.bool,
  scrollbars: PropTypes.bool,
});

export default class PopupWindowLink extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    window: windowShape.isRequired,
  };

  onClick = (event) => {
    event.preventDefault();
    if (this.popupWindow && !this.popupWindow.closed) {
      this.popupWindow.focus();
    } else {
      this.popupWindow = window.open(
        this.props.href,
        this.props.window.name,
        this.getWindowProps()
      );
    }
  };

  getWindowProps() {
    const { name, center, ...windowProps } = this.props.window;
    if (center) {
      const { width, height } = windowProps;
      const windowTop = window.screenTop ? window.screenTop : window.screenY;
      const windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
      windowProps.top = Math.max(0, windowTop + window.innerHeight / 2 - height / 2);
      windowProps.left = Math.max(0, windowLeft + window.innerWidth / 2 - width / 2);
    }
    return encodeProps(windowProps);
  }

  render() {
    return (
      <a href={this.props.href} className={this.props.className} onClick={this.onClick}>
        {this.props.children}
      </a>
    );
  }
}
